import React from "react"
import { Grid } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"

import TextCopyright from "atoms/text/TextCopyright"

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: "#727272",
    paddingTop: "20px",
    paddingBottom: "20px",
  },
  copyright: {
    paddingTop: "22px",
  },
}))

const LinkCentering = () => {
  const classes = useStyles()

  return (
    <Grid
      container
      direction="column"
      justify="center"
      alignItems="center"
      className={classes.container}
    >
      <Grid item className={classes.copyright}>
        <TextCopyright />
      </Grid>
    </Grid>
  )
}

export default LinkCentering
